import type { DocMigration } from "../docMigration";

function isInvalidLevelId(levelId: any) {
  return levelId !== null && typeof levelId !== "string";
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_308: DocMigration = {
  maxSchemaVersion: "0.0.308",
  description: "Clean up invalid levelId data",
  apply(json: any): any {
    // Somehow empty objects have ended up in the levelId values of the view3Ds and elevations of some home files.
    const views: any[] = Object.values(json.view3Ds);
    for (const view of views) {
      if (isInvalidLevelId(view.levelId)) {
        view.levelId = null;
      }
    }
    const elevations: any[] = Object.values(json.elevations);
    for (const elevation of elevations) {
      if (!!elevation.defaultExteriorCamera && isInvalidLevelId(elevation.defaultExteriorCamera.levelId)) {
        elevation.defaultExteriorCamera.levelId = null;
      }
    }
    const optionSets: any[] = Object.values(json.optionSets);
    for (const optionSet of optionSets) {
      const options: any[] = Object.values(optionSet.options);
      for (const option of options) {
        if (!!option.defaultExteriorCamera && isInvalidLevelId(option.defaultExteriorCamera.levelId)) {
          option.defaultExteriorCamera.levelId = null;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_308;
